import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const Decrypt = createAsyncThunk(
  "EncryptionReducer/Decrypt",
  async (parameters, { rejectWithValue }) => {
    try {
await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Encryption/Decrypt",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const EncryptionReducer = createSlice({
  name: "FetchDataJson",
  initialState: {
    DecryptResult: {},
    loadingDecryptResult: false,
    errorDecryptResult: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(Decrypt.pending, (state, action) => {
        state.loadingDecryptResult = true;
        state.DecryptResult = action.payload;
        state.errorJsonData = null;
      })
      .addCase(Decrypt.fulfilled, (state, action) => {
        state.loadingDecryptResult = false;
        state.DecryptResult = action.payload; // Assuming payload has the desired data
      })
      .addCase(Decrypt.rejected, (state, action) => {
        state.loadingDecryptResult = false;
        state.errorDecryptResult = action.payload;
      });
  },
});

export default EncryptionReducer.reducer;
